"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = getResizedColumns;

function getResizedColumns(_ref) {
  var columns = _ref.columns,
      colIndex = _ref.colIndex,
      widthDelta = _ref.widthDelta;
  return columns.map(function (column, index) {
    if (index === colIndex) {
      return _extends({}, column, {
        computedWidth: column.computedWidth + widthDelta,
        isResized: true
      });
    }

    return column;
  });
}